import { Transaction } from '../models/Transaction';
import classNames from 'classnames';

export default function getClassNamesByResponseCode(transaction: Transaction | undefined, mainClassName: string) {
    return classNames(mainClassName,
        {warning: transaction && transaction.responseCode === 2},
        {error: transaction && (transaction.responseCode === 1 || transaction.responseCode === 3)}
    );
}
